import "./Error.404Layout.css";

import React, { useEffect, useState } from "react";

const Error404Layout = () => {
  const [requestedPath, setRequestedPath] = useState("");

  useEffect(() => {
    setRequestedPath(
      window.location.pathname || "/submission/W-NT-30825/12345"
    );
  }, []);

  return (
    <div className="mt-404-wrap">
      <div className="mt-404-right">
        <div className="mt-404-card">
          <div className="mt-404-card-header">
            <p className="mt-404-big404">404</p>
            <p className="mt-404-sub">
              Oops — the page you're looking for does not exist.
            </p>
            <div className="mt-404-meta">MathTounsi · </div>
          </div>

          <div className="mt-404-illustration">
            <svg
              width="320"
              height="220"
              viewBox="0 0 320 220"
              xmlns="http://www.w3.org/2000/svg"
              role="img"
              aria-label="Cartoon: lost variable x with magnifying glass and equations"
            >
              <defs>
                <linearGradient id="g1" x1="0" x2="1">
                  <stop offset="0" stopColor="#ffffff" stopOpacity="0.95" />
                  <stop offset="1" stopColor="#fdf2f4" stopOpacity="0.9" />
                </linearGradient>
              </defs>
              <rect
                rx="14"
                width="320"
                height="220"
                fill="url(#g1)"
                opacity="0.07"
              />

              <g transform="translate(50,50)">
                <circle
                  cx="70"
                  cy="40"
                  r="36"
                  fill="#7A0019d0"
                  stroke="#f2d4d8"
                />
                <circle cx="70" cy="40" r="28" fill="#fdf2f4" />
                <path
                  d="M94 74 L122 102"
                  stroke="#b87385"
                  strokeWidth="8"
                  strokeLinecap="round"
                />
                <circle cx="70" cy="40" r="3" fill="#5a0012" />
              </g>

              <g transform="translate(160,55)">
                <text
                  x="0"
                  y="40"
                  fontSize="64"
                  fontWeight="700"
                  fill="#E43D55"
                  fontFamily="Georgia, serif"
                >
                  x
                </text>
                <circle cx="12" cy="24" r="3" fill="#5a0012" />
                <circle cx="28" cy="24" r="3" fill="#5a0012" />
                <path
                  d="M12 36 Q20 42 28 36"
                  stroke="#5a0012"
                  strokeWidth="2"
                  fill="none"
                  strokeLinecap="round"
                />
              </g>

              <g
                fontFamily="ui-monospace,monospace"
                fontSize="12"
                fill="#7A0019"
              >
                <text x="20" y="18">
                  ∑ a_n = 42
                </text>
                <text x="210" y="28">
                  ∫ x dx = ½ x²
                </text>
                <text x="180" y="110">
                  f(x)=ax²+bx+c
                </text>
                <text x="40" y="170">
                  limₙ→∞ aₙ
                </text>
                <text x="230" y="170">
                  ∀ ε &gt; 0
                </text>
              </g>

              <ellipse
                cx="170"
                cy="190"
                rx="90"
                ry="9"
                fill="#7A0019"
                opacity="0.12"
              />
            </svg>
          </div>
        </div>
      </div>
      <div className="mt-404-left">
        <h1 style={{ color: "#8f0122ff", fontSize: "2.5em" }}>
          MathTounsi — Page Not Found
        </h1>
        <p>
          Looks like this problem got misplaced in the sand dunes of algebra.
          Don’t worry — we’ll help you find your way back to the contest.
        </p>

        <div className="mt-404-code">
          Requested: <strong>{requestedPath}</strong>
        </div>

        <div className="mt-404-mathbits" aria-hidden>
          <div className="mt-404-chip">∑ a_n = ?</div>
          <div className="mt-404-chip">∫₀¹ x² dx</div>
          <div className="mt-404-chip">f'(x)=0</div>
          <div className="mt-404-chip">x = ?</div>
          <div className="mt-404-chip">∀ ε &gt; 0</div>
        </div>

        <div className="mt-404-actions">
          <button
            className="mt-404-btn mt-404-btn-primary"
            onClick={() => (window.location.href = "/")}
          >
            Return home
          </button>
          <button
            className="mt-404-btn mt-404-btn-muted"
            onClick={() => window.history.back()}
          >
            Go back
          </button>
        </div>

        <footer className="mt-404-footer">
          Tip: check the problem reference (e.g. <code>W-NT-30825</code>) and
          the student ID — typos are common.
        </footer>
      </div>
    </div>
  );
};

export default Error404Layout;
